// src/pages/ResumePage.jsx
export default function ResumePage() {
    return (
      <div>
        <h1>My Resume</h1>
        <div style={{ height: "85vh" }}>
          <iframe
            src="/Sunishth_Bhogal_Resume.pdf#view=FitH"
            title="Resume"
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        </div>
      </div>
    );
  }
  